import { render, staticRenderFns } from "./FileChips.vue?vue&type=template&id=177ad86a&scoped=true&"
import script from "./FileChips.vue?vue&type=script&lang=ts&"
export * from "./FileChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177ad86a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChipGroup,VRow})
